/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents/Navigation/Actions/CreateFolder/Content/Name",
  onChange,
  isInvalid
  
}) {
let folderNameValueData = fromData.useDataValue({ viewPath,
context: 'folder',
path: 'name',
})
let folderNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'folder',
path: 'name',
validate: fromValidate.textInput,
required: true,
})
let folderNameChangeData = fromData.useDataChange({ viewPath,
context: 'folder',
path: 'name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 autoFocus={true}
 width="100%"
 marginTop={0}
 data="folder.name"
 value={folderNameValueData}
 onChange={folderNameChangeData}
 required={true}
 validate="/Data/validate.js textInput"
 invalid={!folderNameIsValidData}
 placeholder="Enter name"
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Folder name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}